import { getPatient } from '@/graphql/queries';
import { useMemberstatus } from '@/hooks/useMemberstatus';
import { fetchAuthSession } from 'aws-amplify/auth';
import { useEffect } from 'react';
import { ReservationForm } from '../routes';
import { GetPatientQuery } from '@/API';
import { executeQuery } from '@/client/graphql';
import * as Sentry from '@sentry/react';
import { notMatchCustomErrorMessage } from '@/lib/sentryClient';

/**
 * 属性を持つ会員専用の予約フォーム。
 * @returns
 */
export function ReservationFormMemberstatus() {
  const { navigateNotUserRegistration } = useMemberstatus();

  const fetchRegisteredData = async () => {
    try {
      const session = await fetchAuthSession();

      if (session.userSub) {
        const result = await executeQuery<GetPatientQuery>(getPatient, { id: session.userSub }, 'userPool');

        navigateNotUserRegistration(result.getPatient);
      }
    } catch (error) {
      if (error instanceof Error && notMatchCustomErrorMessage(error.name)) {
        Sentry.captureException(error);
      }

      console.error('Error fetching patient data:', error);
    }
  };
  useEffect(() => {
    fetchRegisteredData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ReservationForm isLogin={true} />;
}
